import { render, staticRenderFns } from "./pointRuleConfig.vue?vue&type=template&id=76c7ffa4&"
import script from "./pointRuleConfig.vue?vue&type=script&lang=js&"
export * from "./pointRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./pointRuleConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c7ffa4')) {
      api.createRecord('76c7ffa4', component.options)
    } else {
      api.reload('76c7ffa4', component.options)
    }
    module.hot.accept("./pointRuleConfig.vue?vue&type=template&id=76c7ffa4&", function () {
      api.rerender('76c7ffa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/pointActivity/pointRuleConfig.vue"
export default component.exports